export const APIEndPoints = {
  merchants: `merchants`,
  products: `products`,
  contracts: 'contracts',
  courses: 'pol/merchant',
  course: 'pol',
  applications: 'applications',
  estimateFees: 'applications/estimatedFees',
  applicationMambuLoanDetails: 'applications/mambuLoanDetails',
  requestNewTerms: 'applications/newTerms',
  loansSearch: 'mambu/loans/search',
  mambuLoan: 'mambu/loan',
  login: 'v1/auth/signIn',
  logout: 'v1/auth/logout',
  passwordReset: 'v1/auth/passwordReset',
  refreshSession: 'v1/auth/refreshToken',
  resetPasswordChallenge: 'v1/auth/signInChallengeResetPassword',
  signInChallenge: 'v1/auth/signInChallengeCode',
  courseJWT: 'v1/auth/token',
  userInfo: 'v1/users/cognito',
  usersPlatform: 'v1/users/platform',
  usersMerchant: 'v1/users/merchant',
  loggedInUser: 'v1/users/loggedIn',
  usersMerchantAdmin: 'v1/users/merchant-admin',
  adminSetUserPassword: 'v1/users/platform/admin/set/pwd',
  sendEmail: 'communication/email'
};
